export default __webpack_public_path__ + "static/media/kap-logo.e8819024.svg";